export const yearlyPlans = [
  import.meta.env.VITE_APP_BUSINESS_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ENTERPRISE_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_VAULT_PRODUCT_YEARLY_PRICE_ID,
];

export const monthlyPlans = [
  import.meta.env.VITE_APP_BUSINESS_PRODUCT_MONTHLY_PRICE_ID,
  import.meta.env.VITE_APP_ENTERPRISE_PRODUCT_MONTHLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_PRODUCT_MONTHLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_VAULT_PRODUCT_MONTHLY_PRICE_ID,
];

export const primaryPlans = [
  import.meta.env.VITE_APP_BUSINESS_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ENTERPRISE_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_BUSINESS_PRODUCT_MONTHLY_PRICE_ID,
  import.meta.env.VITE_APP_ENTERPRISE_PRODUCT_MONTHLY_PRICE_ID,
];

export const secondaryPlans = [
  import.meta.env.VITE_APP_ICRM_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_PRODUCT_MONTHLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_VAULT_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_VAULT_PRODUCT_MONTHLY_PRICE_ID,
];

export const businessLicenses = [
  import.meta.env.VITE_APP_BUSINESS_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_BUSINESS_PRODUCT_MONTHLY_PRICE_ID,
];

export const enterpriseLicenses = [
  import.meta.env.VITE_APP_ENTERPRISE_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ENTERPRISE_PRODUCT_MONTHLY_PRICE_ID,
];

export const icrmLicenses = [
  import.meta.env.VITE_APP_ICRM_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_PRODUCT_MONTHLY_PRICE_ID,
];

export const crmVaultLicenses = [
  import.meta.env.VITE_APP_CRM_VAULT_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_CRM_VAULT_PRODUCT_MONTHLY_PRICE_ID,
];

export const unusableLicenses = [
  import.meta.env.VITE_APP_ICRM_VAULT_PRODUCT_YEARLY_PRICE_ID,
  import.meta.env.VITE_APP_ICRM_VAULT_PRODUCT_MONTHLY_PRICE_ID,
];
